import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-car" }, null, -1)

import { computed, ref, watch } from "vue";
import type { SizeType } from "ant-design-vue/es/config-provider";

interface Props {
  modelValue?: string;
  placeholder?: string;
  disabled?: boolean;
  size?: SizeType;
  allowClear?: boolean;
  status?: "" | "error" | "warning";
  validateOnBlur?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'LicensePlateInput',
  props: {
    modelValue: { default: "" },
    placeholder: { default: "VD: 30A-123.45" },
    disabled: { type: Boolean, default: false },
    size: { default: "middle" },
    allowClear: { type: Boolean, default: true },
    status: { default: "" },
    validateOnBlur: { type: Boolean, default: true }
  },
  emits: ["update:modelValue", "change", "blur", "pressEnter", "validate"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const displayValue = ref("");

/**
 * Chuẩn hóa biển số VN:
 * - 30A12345 / 30A-12345 / 30A-123.45 / 51F1-234.56
 */
const sanitize = (value: string) =>
  value
    .toUpperCase()
    .replace(/[^A-Z0-9.\-]/g, "")
    .slice(0, 12);

const formatPlate = (raw: string) => {
  const clean = raw.replace(/[^A-Z0-9]/g, "");
  if (clean.length <= 2) return clean;
  if (clean.length <= 3) return `${clean.slice(0, 2)}${clean.slice(2)}`;

  // series: digits + letters (2-4 chars after province)
  const match = clean.match(/^(\d{2})([A-Z]{1,2}\d?)(\d{0,5})$/);
  if (!match) return clean;

  const [, province, series, numbers] = match;
  if (!numbers) return `${province}${series}`;

  if (numbers.length <= 3) {
    return `${province}${series}-${numbers}`;
  }
  return `${province}${series}-${numbers.slice(0, 3)}.${numbers.slice(3)}`;
};

const isValidPlate = (value: string) => {
  if (!value) return true;
  // 30A-12345 | 30A-123.45 | 51F1-234.56
  return /^\d{2}[A-Z]{1,2}\d?(?:-\d{3}(?:\.\d{1,2})?|-\d{4,5})$/.test(value);
};

watch(
  () => props.modelValue,
  (val) => {
    displayValue.value = formatPlate(sanitize(val ?? ""));
  },
  { immediate: true }
);

const localError = computed(() => {
  if (!props.validateOnBlur) return false;
  return !!props.modelValue && !isValidPlate(props.modelValue);
});

const computedStatus = computed(() => props.status || (localError.value ? "error" : ""));

const onInput = (val: string) => {
  const formatted = formatPlate(sanitize(val));
  displayValue.value = formatted;
  emit("update:modelValue", formatted);
  emit("change", formatted);
};

const onBlur = (e: FocusEvent) => {
  emit("validate", isValidPlate(props.modelValue ?? ""));
  emit("blur", e);
};

const onPressEnter = (e: KeyboardEvent) => emit("pressEnter", e);

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!

  return (_openBlock(), _createBlock(_component_a_input, {
    value: displayValue.value,
    "onUpdate:value": [
      _cache[0] || (_cache[0] = ($event: any) => ((displayValue).value = $event)),
      onInput
    ],
    placeholder: _ctx.placeholder,
    disabled: _ctx.disabled,
    size: _ctx.size,
    "allow-clear": _ctx.allowClear,
    maxlength: 12,
    status: computedStatus.value,
    class: "ant-license-plate-input",
    onBlur: onBlur,
    onPressEnter: onPressEnter
  }, {
    prefix: _withCtx(() => [
      _hoisted_1
    ]),
    _: 1
  }, 8, ["value", "placeholder", "disabled", "size", "allow-clear", "status"]))
}
}

})